import { billingAppPaths } from '../constants';
import type { Router } from '../types';

export class BillingAppRouterService {
  constructor(private router: Router) {}

  public api() {
    return {
      goToBillingInfo: this.goToBillingInfo,
      goToOverdueBalance: this.goToOverdueBalance,
      goToBillingActivity: this.goToBillingActivity,
      goToManagePaymentPlan: this.goToManagePaymentPlan,
      goToGeneratePrepayInvoice: this.goToGeneratePrepayInvoice,
      goToReactivation: this.goToReactivation,
      goToMoretonBay: this.goToMoretonBay,
      goToMoretonBayConfirmation: this.goToMoretonBayConfirmation,
      getRoute: this.getRoute,
    };
  }

  getRoute = () => {
    return this.router.history.location.pathname;
  };

  goToBillingInfo = ({
    replace = false,
    alerts = {},
    keepParams = false,
  }: {
    replace?: boolean;
    alerts?: { successMessage?: string; errorMessage?: string };
    keepParams?: boolean;
  } = {}) => {
    if (replace) {
      this.replace(billingAppPaths.billinginfo, alerts, keepParams);
    } else {
      this.goTo(billingAppPaths.billinginfo, alerts, keepParams);
    }
  };

  goToOverdueBalance = ({ replace = false, keepParams = false }: { replace?: boolean; keepParams?: boolean } = {}) => {
    if (replace) {
      this.replace(billingAppPaths.overduebalance, {}, keepParams);
    } else {
      this.goTo(billingAppPaths.overduebalance, {}, keepParams);
    }
  };

  goToBillingActivity = () => {
    this.goTo(billingAppPaths.billingactivity);
  };

  goToManagePaymentPlan = () => {
    this.goTo(billingAppPaths.managepaymentplan);
  };

  goToGeneratePrepayInvoice = () => {
    this.goTo(billingAppPaths.generateprepayinvoice);
  };

  goToReactivation = () => {
    this.goTo(billingAppPaths.reactivation);
  };

  goToMoretonBay = () => {
    this.goTo(billingAppPaths.moretonBay);
  };

  goToMoretonBayConfirmation = (firstName: string) => {
    this.goTo(billingAppPaths.moretonBayConfirmation, { firstName });
  };

  // helpers
  private goTo = (path: string, state?: unknown, keepParams?: boolean) => {
    if (keepParams) {
      const { search } = this.router.history.location;

      this.router.history.push({
        pathname: path,
        search,
        state,
      });
    } else {
      this.router.history.push(path, state);
    }
  };

  private replace = (path: string, state?: unknown, keepParams?: boolean) => {
    if (keepParams) {
      const { search } = this.router.history.location;

      this.router.history.replace({
        pathname: path,
        search,
        state,
      });
    } else {
      this.router.history.replace(path, state);
    }
  };
}
